var exports = {
  "D": "x234b8571--03d6b8--title",
};

module.exports = exports;
